import { Button } from 'primereact/button';
import * as React from 'react';
import { GroupServiceGetResponse } from '../../../services/api';
import { APIStatus, GroupStatus } from '../../../utils/types';
import FileUploader from '../../uploads/FileUploader';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { Dialog } from 'primereact/dialog';
import ModalButtons from '../../ui/modals/ModalButtons';
import { submitHighRiskUnlockRequest } from '../../../store/group';

export default function HighRiskRemovalRequestForm({ group, onComplete }: { group: GroupServiceGetResponse, onComplete: () => void }) {
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const [submissionState, setSubmissionState] = React.useState<APIStatus|null>(null);
  const [files, setFiles] = React.useState<File[]>([]);
  const [note, setNote] = React.useState<string>('');

  const formIsValid = React.useMemo<boolean>(() => {
    let isValid = true;

    if (!note.length) isValid = false;

    return isValid;
  }, [files, note]);

  async function handleFormSubmit() {
      try {
            setSubmissionState(APIStatus.LOADING);
      
            await submitHighRiskUnlockRequest({
              policyNumber: group.policyDetailModel?.policyNumber!,
              file: files[0],
              note,
            });
  
            onComplete();
            setIsModalVisible(false);
            setSubmissionState(APIStatus.COMPLETE);
          } catch {
            setSubmissionState(APIStatus.ERROR);
          }
    }

  return (
    <div className="flex flex-col">
      <Button
        rounded
        label="request to unlock group" icon="pi pi-lock-open"
        onClick={() => setIsModalVisible(true)}
        disabled={group.requestStatus === GroupStatus.HIGH_RISK_REQUESTED}
      />

      <Dialog
        draggable={false}
        header={
          <>  
            <div>Request to unlock group</div>
            <p className="text-base font-normal">
              Provide supporting notes and documentation for Actuarial review
            </p>
          </>
        }
        visible={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        footer={
          <ModalButtons
            isFormValid={formIsValid}
            isLoading={submissionState === APIStatus.LOADING}
            onCancel={() => setIsModalVisible(false)}
            onSave={handleFormSubmit}
          />
        }
      >
        <div className="flex flex-col gap-4">
        
          <div className="flex flex-col gap-2">
            <FileUploader files={files} onAddFile={(e) => setFiles(e)} />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="notes" className="font-bold">Supporting notes</label>
            <InputTextarea value={note} onChange={(e) => setNote(e.target.value)} id="notes" rows={5} placeholder="Add supporting notes" />
          </div>
        </div>

        {submissionState === APIStatus.ERROR && (
          <div className="flex flex-col mt-4">
            <Message severity="error" text="There was an error submitting your request, please try again" />
          </div>
        )}
      </Dialog>  
    </div>
  )
}